import { AuthActions, AuthSelectors } from '@web_opxp/features';
import { LanguageSelectors } from '@web_opxp/language';
import { connect } from 'react-redux';
import { Action, Dispatch } from 'redux';
import HeaderWrapper from '../components/header/HeaderWrapper';
import * as Selectors from './selectors';

export const mapStateToProps = (state: any) => {
  const langLoading = LanguageSelectors.isLoading(state);
  const appLoading = !Selectors.isCheckoutReady(state);
  const isFreshPremium = Selectors.isFreshPremium(state);
  const isPremium = AuthSelectors.isPremium(state) || isFreshPremium;
  const session = AuthSelectors.getToken(state);
  const regular = AuthSelectors.getUnreadMessages(state);
  const friendship = AuthSelectors.getFriendRequests(state);
  const picture = AuthSelectors.getUserPicture(state);
  const authorized = AuthSelectors.isAuthorized(state);
  const alias = AuthSelectors.getUserEmail(state);
  const isLoggedIn = AuthSelectors.isLoggedIn(state);
  return {
    loading: langLoading || appLoading,
    isPremium,
    session,
    regular,
    friendship,
    picture,
    authorized,
    alias,
    isLoggedIn,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onUserMenuAction: (actionType: string) => dispatch({ type: actionType } as Action),
    onLogin: () => dispatch(AuthActions.redirectToSSO()),
  };
};

const HeaderWrapperConnected = connect(mapStateToProps, mapDispatchToProps)(HeaderWrapper);
export default HeaderWrapperConnected;
